export default __webpack_public_path__ + "img/62eed44cea81f117d9a991b9805138c8.svg";